import { Config, makeFetcher } from '@/utils/fetch';
import { config } from '@/config';
import {
    ISurveyHistoryData,
    ISurveyOpportunityData,
    IContinueSurveyData,
} from '@/types/types/forms/survey/survey.interface';
import { getJson } from '@/utils/fp';
import { createQueryParamString } from '@/utils/fp/route/queryParams';

const makeSurveyService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);

    return {
        getSurveys: async (
            offset: number,
            limit: number,
            userId?: string,
            surveyKey?: string,
            reCaching?: boolean,
            disableRedirects = true,
        ) =>
            fetcher
                .get(
                    createQueryParamString({
                        offset: String(offset),
                        limit: String(limit),
                        userId,
                        surveyKey,
                        reCaching: reCaching ? 'true' : 'false',
                    }),
                    { disableRedirects },
                )
                .then(getJson) as Promise<{ data: ISurveyOpportunityData[]; count: number }>,

        getSurveyHistory: async (year: number, config?: Config) =>
            fetcher.get(`/history?year=${year}`, config).then(getJson) as Promise<
                ISurveyHistoryData[]
            >,

        continueSurvey: async (surveyKey: string, userId: string) =>
            fetcher
                .get(
                    `/link/continue${createQueryParamString({
                        surveyKey,
                        userId,
                    })}`,
                    { disableRedirects: true },
                )
                .then(getJson) as Promise<IContinueSurveyData>,
    };
};

export const surveyService = makeSurveyService(config.api.url.survey);
